module.exports = __webpack_public_path__ + "static/media/bonarka04.7bbc72d1.jpg";